import type { IComponentController, IScope } from "angular";

import type { IUserInformation } from "App/Modules/Models";

export class UserInfoTableComponentController implements IComponentController {
    public static $inject: string[] = ["$scope"];

    public user: IUserInformation;

    constructor(private readonly $scope: IScope) {}

    public $onInit() {
        // console.log("test2323");
    }
}
